exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cover-9ea0b335{height:81px;width:516px;object-fit:cover}.plusIcon-28e3d478{border:2px solid #E0E0E0;border-radius:50%;display:block;margin:0 auto;background:#FFF;object-fit:cover}\n", ""]);

// Exports
exports.locals = {
	"cover": "cover-9ea0b335",
	"plusIcon": "plusIcon-28e3d478"
};